import { IRouteMeta, IRouteMetadata } from '@/types';

export const routeMetadata: IRouteMetadata = {
    user: {
        requiresAuth: true,
        namePage: '[User name]',
        descPage: 'Flood Alert user profile page',
    } as IRouteMeta,
    dashboard: {
        requiresAuth: true,
        namePage: 'My Dashboard Page',
        descPage: '',
    } as IRouteMeta,
    subscriber: {
        requiresAuth: true,
        namePage: 'Subscriber List',
        descPage: 'Main list of all Flood Alert 360 subscribers',
    } as IRouteMeta,
    subscriberProfile: {
        requiresAuth: true,
        namePage: 'Subscriber Profile Page',
        descPage: '[Subscriber name] [Subscriber Last Name]',
        pageBack: '/subscriber',
    } as IRouteMeta,
    marketing: {
        requiresAuth: true,
        namePage: 'Marketing Page',
        descPage: 'Generate links to use in marketing campaigns and explode our pre-made marketing materials',
    } as IRouteMeta,
    marketingGallery: {
        requiresAuth: true,
        namePage: 'Marketing Assets Gallery ',
        descPage: 'Explode our pre-made marketing materials',
        pageBack: '/marketing',
    } as IRouteMeta,
    marketingPattrens: {
        requiresAuth: true,
        namePage: 'Patterns',
        descPage: 'Use FloodAlert patterns as themed background for marketing content ',
        pageBack: '/marketing',
    } as IRouteMeta,
    marketingLink: {
        requiresAuth: true,
        namePage: '[Link name]',
        descPage: 'Marketing link analytics',
        pageBack: '/marketing',
    } as IRouteMeta,
    companies: {
        requiresAuth: true,
        namePage: 'Companies',
        descPage: 'Sеlect an insurance company to view FloodAlert from their perspective',
    } as IRouteMeta,
    companyUser: {
        requiresAuth: true,
        namePage: '[User name]',
        descPage: 'Flood Alert user profile page',
        pageBack: '/companies',
    } as IRouteMeta,
    companyAccount: {
        requiresAuth: true,
        namePage: '[Company Name]',
        descPage: 'Flood Alert user profile page',
        pageBack: '/companies',
    } as IRouteMeta,
    management: {
        requiresAuth: true,
        namePage: 'Team Management',
        descPage: 'Management dashboard for team settings',
    } as IRouteMeta,
    company_management: {
        requiresAuth: true,
        namePage: '[Company Name] Team',
        descPage: 'Management dashboard for team settings',
		pageBack: '/companies',
    } as IRouteMeta,
    companyProfile: {
        requiresAuth: true,
        namePage: 'Company Profile',
        descPage: '[Company Name]',
		pageBack: '/companies',
    } as IRouteMeta,
    myCompanyProfile: {
        requiresAuth: true,
        namePage: 'Company Profile',
        descPage: '[Company Name]',
    } as IRouteMeta,
    reportsShipping: {
        requiresAuth: true,
        namePage: 'Shipping & Fulfillment',
        descPage: 'Oversee order fulfillment and track orders',
    } as IRouteMeta,
    reportsShippingAll: {
        requiresAuth: true,
        namePage: 'Shipping & Fulfillment',
        descPage: 'Oversee order fulfillment and track orders',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    orderPendingShipments: {
        requiresAuth: true,
        namePage: 'Order Pending Shipments',
        descPage: 'View all orders that have not been shipped yet.',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    inTransitShipments: {
        requiresAuth: true,
        namePage: 'In Transit Shipments',
        descPage: 'View all orders that have been shipped and are in transit.',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    runningLateShipments: {
        requiresAuth: true,
        namePage: 'Running Late Shipments',
        descPage: 'View all orders that have been shipped and are running late.',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    issueShipments: {
        requiresAuth: true,
        namePage: 'Issue Shipments',
        descPage: 'View all orders that have been shipped an issue with delivery.',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    deliveredShipments: {
        requiresAuth: true,
        namePage: 'Delivered Shipments',
        descPage: 'View all orders that have been delivered.',
        pageBack: '/reports-shipping',
    } as IRouteMeta,
    reportsActivity: {
        requiresAuth: true,
        namePage: 'Alarms Activity',
        descPage: 'Keep track of current alarms and response frequency or view passed data by selecting a different time period in filters ',
    } as IRouteMeta,
    reportsClaims: {
        requiresAuth: true,
        namePage: 'Claims',
        descPage: 'Generate links to use in marketing campaigns and explode our pre-made marketing materials',
    } as IRouteMeta,
    reportsClaimsAccount: {
        requiresAuth: true,
        namePage: '[Claim report name]',
        descPage: 'Claims report',
				pageBack: '/reports-claims',
    } as IRouteMeta,
    reportsEvents: {
        requiresAuth: true,
        namePage: 'Events',
        descPage: 'Upcoming and past events reports',
    } as IRouteMeta,
    reportsSubscribers: {
        requiresAuth: true,
        namePage: 'Subscribers',
        descPage: 'Reports on subscriber engagement and data',
    } as IRouteMeta,
    patterns: {
        requiresAuth: true,
        namePage: 'Patterns',
        descPage: 'UI/UX patterns for application development',
    } as IRouteMeta,
    resetPassword: {
        requiresAuth: false,
        namePage: 'Reset Password',
        descPage: 'Allows users to initiate password reset',
    } as IRouteMeta,
    resetNewPassword: {
        requiresAuth: false,
        namePage: 'Set New Password',
        descPage: 'Allows users to set a new password',
    } as IRouteMeta,
    error404: {
        requiresAuth: false,
        namePage: '404 Not Found',
        descPage: 'Page not found error message',
    } as IRouteMeta,
    login: {
        requiresAuth: false,
        redirectIfAuthed: true,
        namePage: 'Login Page',
        descPage: 'Login page for user authentication',
    } as IRouteMeta,
    registration: {
        requiresAuth: false,
        redirectIfAuthed: false,
        namePage: 'Insurance Enrollment',
        descPage: 'Insurance customer registration',
    } as IRouteMeta,
    retailRegistration: {
        requiresAuth: false,
        redirectIfAuthed: false,
        namePage: 'Retail Registration',
        descPage: 'Retail customer registration',
    } as IRouteMeta,
    client: {
        requiresAuth: true,
        subscriberPage: true,
        namePage: 'Client Page',
        descPage: 'Client for user',
    } as IRouteMeta,
    clientContact: {
        requiresAuth: true,
        subscriberPage: true,
        namePage: 'Client Contact Page',
        descPage: 'Client Contact for user',
    } as IRouteMeta,
    clientDevices: {
        requiresAuth: true,
        subscriberPage: true,
        namePage: 'Client Devices Page',
        descPage: 'Client Devices for user',
    } as IRouteMeta,
    resolveIssue: {
        requiresAuth: false,
        subscriberPage: true,
        redirect: false,
        namePage: 'Resolve',
        descPage: 'Resolve',
    } as IRouteMeta,
};